import InvitationsComp, { ModalKeys } from "../../components/pages/invitations";
import { useParams, useHistory, useLocation } from "react-router-dom";
export { ModalKeys } from "../../components/pages/invitations";
function Invitations() {
  const history = useHistory();
  const location = useLocation();
  let { modal, invitationId, secondaryId } = useParams<any>();
  const resolveBase = () => {
    let base: string = location.pathname;
    if (modal) {
      base = base.replace(`/${modal}`, "");
    }
    if (invitationId) {
      base = base.replace(`/${invitationId}`, "");
    }
    if (secondaryId) {
      base = base.replace(`/${secondaryId}`, "");
    }

    if (base.endsWith("/")) {
      base = base.substr(0, base.length - 1);
    }
    return base;
  };
  const onShowModal = (key: ModalKeys, invId?: string, secId?: string) => {
    let path: string[] = [resolveBase()];
    if (invId) {
      path.push(invId);
    }
    path.push(key);
    if (secId) {
      path.push(secId);
    }
    history.push(path.join("/"));
  };
  const onHideModal = (callback?: () => void) => {
    history.push(resolveBase());

    if (callback && typeof callback === "function") {
      callback();
    }
  };
  return (
    <InvitationsComp
      showModal={{ key: modal as ModalKeys, invitationId, secondaryId }}
      onShowModal={onShowModal}
      onHideModal={onHideModal}
    />
  );
}
export default Invitations;
